import MainContainer from "components/sections/MainContainer";
import MapView from "components/blocks/MapView";
import MetaHead from "components/base/MetaHead";

export default function RangeSimulator() {
  return (
    <MainContainer navStyle={{ gradient: true, inverted: false }} noFooter>
      <MetaHead title="LBL_RANGE_SIMULATOR_META_TITLE" />
      <MapView />
    </MainContainer>
  );
}
